var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { t } from 'i18next';
import { postApi } from '../../../utils/fetcher';
import { updateEvent } from '../../../utils/updateEvent';
import { animate, fade } from '@lit-labs/motion';
import '../../../components/textArea';
import './pages';
import './page';
import { BaseComponent } from '../../../utils/BaseComponent';
import { customElement } from 'lit/decorators.js';
import { reportContext } from '../context/ReportContext';
import { consume } from '@lit-labs/context';
import { isEmpty } from '../../../utils/stringUtils';
import { replyContext } from '../context/ReplyContext';
import { createToast } from '../../../components/toast/toastUtil';
import { trackEvent } from '../../../utils/trackPulse';
let Report = class Report extends BaseComponent {
    constructor() {
        super(...arguments);
        this.closeReport = (clickedOverlay) => {
            trackEvent({
                name: `Exit report`,
                intent: 'Close',
                type: 'Click',
                position: this.position,
            }, `Close report ${clickedOverlay ? 'overlay' : 'close/cancel button'}`, `${clickedOverlay ? 'overlay' : 'button'}`, this.vertical);
            this.report.setContext({ show: false });
        };
    }
    render() {
        var _a, _b, _c;
        return html `
      <trust-experiment experiment="trust.my.feedback.report" group="control">
        ${this.report.show
            ? html `
              <div class="mt-16 flex flex-col" ${animate({ in: fade })}>
                <div>
                  <trust-text-area
                    autoFocus
                    .value=${this.report.input}
                    classNames="h-48"
                    maxLength="500"
                    @input=${(e) => {
                this.report.setContext({ input: e.detail.value });
            }}
                  >
                    <p class="detail text-secondary">
                      ${((_a = this.report.input) === null || _a === void 0 ? void 0 : _a.length) || 0}/500. Rapportér hvis du mener
                      vurderingen inneholder trusler eller trakassering, eller
                      hvis handelen ikke har funnet sted.
                    </p>
                  </trust-text-area>
                </div>
                <div class="mt-8 flex justify-end gap-16">
                  <div class="flex gap-16">
                    <trust-button
                      dataTest="cancel"
                      small
                      quiet
                      destructive
                      @click="${() => this.closeReport(false)}"
                      >${t('Cancel')}</trust-button
                    >
                    <trust-button
                      dataTest="submit"
                      primary
                      small
                      ?disabled="${((_b = this.report.input) === null || _b === void 0 ? void 0 : _b.length) === 0}"
                      @click="${() => {
                sendInnReport(this);
            }}"
                    >
                      ${t('Submit')}
                    </trust-button>
                  </div>
                </div>
              </div>
            `
            : nothing}
      </trust-experiment>
      <trust-experiment
        experiment="trust.my.feedback.report"
        group="challenger"
      >
        <trust-modal
          ?show=${this.report.show}
          ?hideButtons=${true}
          @cancel=${() => this.closeReport(true)}
          destructive
        >
          <trust-pages
            @close=${(e) => this.closeReport(e.detail.clickedOverlay)}
            @confirm=${async (e) => {
            await sendInnReport(this);
            createToast({
                id: 'report-success',
                type: 'success',
                text: 'Rapporteringen er mottatt. Vi ser på saken så snart vi kan.',
                canClose: true,
            });
            e.detail.target.dispatchEvent(new CustomEvent('reset', { bubbles: true, composed: true }));
        }}
            @next=${(e) => {
            trackEvent({
                name: `Go to next step`,
                intent: 'Open',
                type: 'Click',
                position: this.position,
            }, `Go to next step`, `button`, this.vertical, `Report page nr ${e.detail.page}`);
        }}
            @back=${(e) => {
            trackEvent({
                name: `Go back to previous page`,
                intent: 'Open',
                type: 'Click',
                position: this.position,
            }, `Go back to previous page`, `button`, this.vertical, `Report page nr ${e.detail.page}`);
        }}
          >
            <trust-page
              header="Misfornøyd med en vurdering?"
              classNames="flex flex-col gap-16"
              first
              hideContinue
            >
              <p>
                Vi vet at det kan føles urettferdig å få en dårlig vurdering, og
                det har vi full forståelse for.
              </p>
              <p class="strong">Dette kan du gjøre</p>
              <div class="flex items-center">
                <trust-icon
                  classNames="shrink-0 w-32 h-32 mr-24"
                  name="Communication"
                ></trust-icon>
                <div>
                  <p class="caption">
                    Kontakt avsender. I mange tilfeller er dette den raskeste
                    måten å finne en god løsning.
                  </p>
                  <trust-button
                    link
                    @click=${() => {
            trackEvent({
                name: `Close report and go to a new message`,
                intent: 'Close',
                type: 'Click',
                position: this.position,
            }, `Go to new message`, `button`, this.vertical);
            this.report.setContext({ show: false });
            window.location.href = `/meldinger/ny/${this.report.externalItemId}`;
        }}
                    classNames="caption strong mt-8 block"
                    >Kontakt avsender</trust-button
                  >
                </div>
              </div>
              <div class="flex items-center">
                <trust-icon
                  classNames="shrink-0 w-32 h-32 mr-24"
                  name="Reply"
                ></trust-icon>
                <div>
                  <p class="caption">
                    For å få fram din side av saken, kan du skrive et svar som
                    vises under vurderingen på profilen din.
                  </p>
                  <trust-button
                    @click=${() => {
            trackEvent({
                name: `Close report and go to reply`,
                intent: 'Close',
                type: 'Click',
                position: this.position,
            }, `Go to reply`, `button`, this.vertical);
            this.report.setContext({ show: false });
            this.reply.setContext({ show: true });
        }}
                    link
                    classNames="caption strong mt-8"
                    >Skriv et svar</trust-button
                  >
                </div>
              </div>
              <div class="flex items-center">
                <trust-icon
                  classNames="shrink-0 w-32 h-32 mr-24"
                  name="Support"
                ></trust-icon>
                <div>
                  <p class="caption">
                    Dersom vurderingen inneholder trusler, trakassering eller
                    sensitiv informasjon, eller handelen ikke har skjedd, kan du
                    kontakte kundesenteret.
                  </p>
                  <trust-button
                    classNames="caption strong mt-8"
                    link
                    data-test="contact-support"
                    @click=${(e) => {
            e.target.dispatchEvent(new CustomEvent('next', {
                bubbles: true,
                composed: true,
            }));
        }}
                    >Kontakt kundesenteret</trust-button
                  >
                </div>
              </div>
            </trust-page>
            <trust-page
              classNames="flex flex-col gap-16"
              header="Fortell oss hva som skjedde"
              .verify=${() => {
            if (this.report.tradeHappened !== undefined &&
                this.report.sensitive !== undefined) {
                this.report.setContext({ error: false });
                return true;
            }
            else {
                this.report.setContext({ error: true });
                return false;
            }
        }}
            >
              <div aria-labelledby="DidTradeHappen" class="flex flex-col">
                <p class="p p-strong" id="DidTradeHappen">
                  Ble handelen gjennomført?
                </p>
                <div class="mt-8">
                  <input
                    name="tradeHappened"
                    id="yesTradehappened"
                    type="radio"
                    .checked=${this.report.tradeHappened === true}
                    @change=${() => {
            this.report.setContext({ tradeHappened: true });
        }}
                  />
                  <label class="p" for="yesTradehappened"
                    >Ja, overlevering og betaling er fullført</label
                  >
                </div>
                <div class="mt-16">
                  <input
                    name="tradeHappened"
                    id="noTradehappened"
                    type="radio"
                    .checked=${this.report.tradeHappened === false}
                    @change=${() => {
            this.report.setContext({ tradeHappened: false });
        }}
                  />
                  <label class="p" for="noTradehappened"> Nei </label>
                </div>
                ${this.report.error && this.report.tradeHappened === undefined
            ? html `<p class="caption text-red-600">
                      Du må velge et av alternativene for å kunne gå videre
                    </p>`
            : nothing}
              </div>
              <div aria-labelledby="sensitive">
                <label class="p p-strong" for="sensitive">
                  Inneholder vurderingen trusler, trakassering eller sensitiv
                  informasjon?</label
                >
                <div class="mt-8">
                  <input
                    id="yesSensitive"
                    name="sensitive"
                    type="radio"
                    .checked=${this.report.sensitive === true}
                    @change=${() => {
            this.report.setContext({ sensitive: true });
        }}
                  />
                  <label class="p" for="yesSensitive"> Ja </label>
                </div>
                <div class="mt-16">
                  <input
                    name="sensitive"
                    id="noSensitive"
                    type="radio"
                    .checked=${this.report.sensitive === false}
                    @change=${() => {
            this.report.setContext({ sensitive: false });
        }}
                  />
                  <label class="p" for="noSensitive"> Nei </label>
                </div>
                ${this.report.error && this.report.sensitive === undefined
            ? html `<p class="caption text-red-600">
                      Du må velge et av alternativene for å kunne gå videre
                    </p>`
            : nothing}
              </div>
            </trust-page>
            <trust-page
              header=${this.report.sensitive || !this.report.tradeHappened
            ? 'Fortell oss hva som skjedde'
            : 'Vil du hjelpe oss å forbedre FINN?'}
              .verify=${() => {
            if (!isEmpty(this.report.input)) {
                this.report.setContext({ error: false });
                return true;
            }
            else {
                this.report.setContext({ error: true });
                return false;
            }
        }}
              last
            >
              <label class="p p-strong mb-8" for="reportText">
                ${this.report.sensitive || !this.report.tradeHappened
            ? `Hva er problemet med vurderingen?`
            : `Selv om vi dessverre ikke kan slette denne vurderingen, vil vi gjerne høre om din opplevelse. Vi leser det du sender inn, men svarer ikke.`}
              </label>
              <trust-text-area
                id="reportText"
                autoFocus
                classNames="h-96"
                .value=${this.report.input}
                maxLength="500"
                @input=${(e) => {
            this.report.setContext({ input: e.detail });
        }}
              >
                <p class="detail text-secondary">
                  ${((_c = this.report.input) === null || _c === void 0 ? void 0 : _c.length) || 0}/500 tegn.
                </p>
              </trust-text-area>
              ${this.report.error
            ? html `<p class="caption text-red-600">
                    Du må skrive en forklaring slik at vi kan bedre forstå hva
                    som har skjedd.
                  </p>`
            : nothing}
            </trust-page>
          </trust-pages>
        </trust-modal>
      </trust-experiment>
    `;
    }
};
__decorate([
    consume({ context: reportContext, subscribe: true })
], Report.prototype, "report", void 0);
__decorate([
    consume({ context: replyContext, subscribe: true })
], Report.prototype, "reply", void 0);
Report = __decorate([
    customElement('trust-report-button')
], Report);
export { Report };
const sendInnReport = async (element) => {
    const { sensitive, tradeHappened, input, tradeId } = element.report;
    if (!tradeId) {
        console.error('No tradeId found');
    }
    else {
        const claim = tradeHappened === true && sensitive === false
            ? 'NO_RULE_VIOLATION'
            : 'RULE_VIOLATION';
        try {
            await postApi({
                claim,
                comment: input,
                sensitive,
                tradeHappened,
            }, `/claims/${tradeId}`, window.trustSettings);
            trackEvent({
                name: `Send inn report ${claim}`,
                intent: 'Confirm',
                type: 'Click',
                position: element.position,
            }, 'Send inn report', 'button', element.vertical);
            element.report.setContext({ show: false });
            // Wait for the modal to close
            setTimeout(() => {
                element.report.reset();
            }, 300);
            element.report.reset();
            dispatchEvent(updateEvent);
        }
        catch (e) {
            throw e;
        }
    }
};
//# sourceMappingURL=Report.js.map